import VWave from 'v-wave'

// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'
import icons from '@/iconify/index.json'
// 自定义指令
import directive from '@/utils/directive'
// 错误日志上报
import errorLog from '@/utils/errorLog'

import App from './App.vue'
import i18n from './locales'
import router from './router'
import pinia from './store'
import uiProvider from './ui/provider'
import '@/utils/storage'
import '@/utils/systemCopyright'

// 加载 svg 图标
import 'virtual:svg-icons-register'
// UnoCSS
import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
// 全局样式
import '@/assets/styles/globals.css'

const app = createApp(App)
app.use(VWave, {})
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(i18n)
directive(app)
errorLog(app)

// 修复 wheel 事件警告：为 wheel 事件添加 passive 监听器
// 这可以改善滚动性能，避免浏览器警告
if (typeof window !== 'undefined') {
  // 拦截 addEventListener，为 wheel 事件自动添加 passive 选项
  const originalAddEventListener = EventTarget.prototype.addEventListener
  EventTarget.prototype.addEventListener = function (type: string, listener: any, options?: any) {
    if (type === 'wheel' || type === 'mousewheel') {
      // 如果 options 是对象，添加 passive；如果是布尔值，转换为对象
      if (typeof options === 'boolean') {
        options = { capture: options, passive: true }
      }
      else if (typeof options === 'object' && options !== null) {
        options = { ...options, passive: true }
      }
      else {
        options = { passive: true }
      }
    }
    return originalAddEventListener.call(this, type, listener, options)
  }
}
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

app.mount('#app')
